import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/axios';

export default function PreviewBanner() {
    const navigate = useNavigate();
    const [info, setInfo] = useState(null);

    useEffect(() => {
        if (!sessionStorage.getItem('previewToken')) return;
        api.get('/preview/validate/')
            .then(res => {
                if (res.data.valid) {
                    const expires = new Date(res.data.expires_at);
                    const formatted = expires.toLocaleDateString('cs-CZ', { day: '2-digit', month: '2-digit', year: 'numeric' });
                    setInfo({ companyName: res.data.company_name, expiresAt: formatted });
                    if (sessionStorage.getItem('previewFirstVisit')) {
                        sessionStorage.removeItem('previewFirstVisit');
                        navigate(`/estate/list/1/?company_id=${res.data.company_id}`);
                    }
                } else {
                    sessionStorage.removeItem('previewToken');
                }
            })
            .catch(() => {});
    }, []);

    if (!info) return null;

    return (
        <div style={{
            background: '#1a3a6b',
            color: '#fff',
            fontSize: '0.8rem',
            padding: '6px 16px',
            textAlign: 'center',
            letterSpacing: '0.02em',
        }}>
            Náhled partnera &mdash; <strong>{info.companyName}</strong> &mdash; platnost do {info.expiresAt}
        </div>
    );
}
